if (!customElements.get('free-shipping-bar')) {
  class FreeShippingBar extends HTMLElement {
  constructor() {
    super();
    this.threshold = parseInt(this.dataset.freeShippingThreshold) || 119900;
    this.progressFill = this.querySelector('.free-shipping-bar__progress-fill');
    this.progressIndicator = this.querySelector('.free-shipping-bar__progress-indicator');
    this.messageElement = this.querySelector('.free-shipping-bar__message');
    this.percentageElement = this.querySelector('.free-shipping-bar__percentage');
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.handleCartUpdate.bind(this));
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  async handleCartUpdate(event) {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) throw new Error('Failed to fetch cart');
      
      const cart = await response.json();
      this.updateFromCart(cart);
    } catch (error) {
      console.error('Error updating free shipping bar:', error);
    }
  }

  updateFromCart(cart) {
    const remaining = this.threshold - cart.total_price;
    const percentage = Math.min(Math.max((cart.total_price / this.threshold) * 100, 0), 100);
    
    // Update progress bar with animation
    if (this.progressFill) {
      this.progressFill.style.width = `${percentage}%`;
    }
    
    // Update indicator position
    if (this.progressIndicator) {
      this.progressIndicator.style.left = `${percentage}%`;
      
      if (this.percentageElement) {
        this.percentageElement.textContent = `${Math.round(percentage)}%`;
      }
      
      // Hide indicator when at 100%
      if (percentage >= 100) {
        this.progressIndicator.style.display = 'none';
      } else {
        this.progressIndicator.style.display = '';
      }
    }
    
    // Update message
    if (this.messageElement) {
      const messageText = this.messageElement.querySelector('.free-shipping-bar__text');
      if (messageText) {
        if (cart.item_count === 0) {
          messageText.innerHTML = this.formatMessage('empty', cart);
          messageText.classList.remove('free-shipping-bar__text--success');
        } else if (remaining > 0) {
          messageText.innerHTML = this.formatMessage('remaining', cart, remaining);
          messageText.classList.remove('free-shipping-bar__text--success');
        } else {
          messageText.innerHTML = this.formatMessage('qualified', cart);
          messageText.classList.add('free-shipping-bar__text--success');
        }
      }
    }
    
    // Update progress bar aria attributes
    const progressBar = this.querySelector('.free-shipping-bar__progress');
    if (progressBar) {
      progressBar.setAttribute('aria-valuenow', Math.round(percentage));
    }
  }

  formatMessage(type, cart, remaining = 0) {
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: cart.currency || 'USD'
    });
    
    switch (type) {
      case 'empty':
        const thresholdFormatted = formatter.format(this.threshold / 100);
        return `Add ${thresholdFormatted} to your cart for free shipping!`;
      
      case 'remaining':
        const remainingFormatted = formatter.format(remaining / 100);
        return `You're ${remainingFormatted} away from free shipping!`;
      
      case 'qualified':
        const checkmark = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-checkmark" viewBox="0 0 12 9"><path fill="currentColor" fill-rule="evenodd" d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z" clip-rule="evenodd"/></svg>';
        return checkmark + ' You qualify for free shipping!';
      
      default:
        return '';
    }
  }
}

  customElements.define('free-shipping-bar', FreeShippingBar);
}

// Initialize free shipping bars on DOMContentLoaded
document.addEventListener('DOMContentLoaded', async () => {
  // Fetch initial cart state and update all bars
  try {
    const response = await fetch('/cart.js');
    if (response.ok) {
      const cart = await response.json();
      document.querySelectorAll('free-shipping-bar').forEach(bar => {
        bar.updateFromCart(cart);
      });
    }
  } catch (error) {
    console.error('Error initializing free shipping bars:', error);
  }
});